module.exports = __webpack_public_path__ + "img/info-rr.e2310746.svg";